/**
 * Client-side OpenTelemetry initialisation — Next.js 15.3+ official hook.
 *
 * Next.js guarantees this file runs BEFORE hydration and before any of the
 * app's own code executes on the client. This ensures FetchInstrumentation
 * patches window.fetch before the very first outgoing call (token refresh,
 * auth hydration, etc.) so no requests slip out without a traceparent header.
 *
 * The TelemetryProvider in the layout still calls initClientTelemetry() inside
 * a useEffect — that call becomes a silent no-op thanks to the idempotency
 * guard in initClientTelemetry (if (provider) return).
 */

import { initClientTelemetry } from "@repo/telemetry/src/otel-client";

initClientTelemetry({
  serviceName: "jetsmart-main-client",
  otlpEndpoint: process.env.NEXT_PUBLIC_OTEL_EXPORTER_OTLP_ENDPOINT,
});
